/**
 * Calendar Constants
 * Shared constants for calendar functionality
 */

import {
  ClockIcon,
  BuildingOfficeIcon,
  VideoCameraIcon,
  PhoneIcon,
  HomeIcon,
  RocketLaunchIcon,
  PresentationChartBarIcon,
  AcademicCapIcon,
  StarIcon
} from '@heroicons/react/24/outline';
import { EventCategory } from '@/types/calendar';

export const monthNames = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

export const weekDays = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];

export const eventCategories: EventCategory[] = [
  {
    id: 'meeting-presencial',
    name: 'Reunión Presencial',
    color: 'text-blue-800',
    bgColor: 'bg-blue-100',
    borderColor: 'border-blue-200',
    darkColor: 'dark:text-blue-200',
    darkBgColor: 'dark:bg-blue-900/40',
    darkBorderColor: 'dark:border-blue-700',
    icon: BuildingOfficeIcon,
    description: 'Reuniones cara a cara en oficina o lugar físico'
  },
  {
    id: 'meeting-virtual',
    name: 'Reunión Virtual',
    color: 'text-green-800',
    bgColor: 'bg-green-100',
    borderColor: 'border-green-200',
    darkColor: 'dark:text-green-200',
    darkBgColor: 'dark:bg-green-900/40',
    darkBorderColor: 'dark:border-green-700',
    icon: VideoCameraIcon,
    description: 'Videoconferencias y reuniones online'
  },
  {
    id: 'call',
    name: 'Llamada',
    color: 'text-purple-800',
    bgColor: 'bg-purple-100',
    borderColor: 'border-purple-200',
    darkColor: 'dark:text-purple-200',
    darkBgColor: 'dark:bg-purple-900/40',
    darkBorderColor: 'dark:border-purple-700',
    icon: PhoneIcon,
    description: 'Llamadas telefónicas de seguimiento'
  },
  {
    id: 'visit-project',
    name: 'Visita a Proyecto',
    color: 'text-orange-800',
    bgColor: 'bg-orange-100',
    borderColor: 'border-orange-200',
    darkColor: 'dark:text-orange-200',
    darkBgColor: 'dark:bg-orange-900/40',
    darkBorderColor: 'dark:border-orange-700',
    icon: HomeIcon,
    description: 'Visitas a proyectos inmobiliarios'
  },
  {
    id: 'launch-event',
    name: 'Lanzamiento',
    color: 'text-pink-800',
    bgColor: 'bg-pink-100',
    borderColor: 'border-pink-200',
    darkColor: 'dark:text-pink-200',
    darkBgColor: 'dark:bg-pink-900/40',
    darkBorderColor: 'dark:border-pink-700',
    icon: RocketLaunchIcon,
    description: 'Eventos de lanzamiento de proyectos'
  },
  {
    id: 'presentation',
    name: 'Presentación',
    color: 'text-indigo-800',
    bgColor: 'bg-indigo-100',
    borderColor: 'border-indigo-200',
    darkColor: 'dark:text-indigo-200',
    darkBgColor: 'dark:bg-indigo-900/40',
    darkBorderColor: 'dark:border-indigo-700',
    icon: PresentationChartBarIcon,
    description: 'Presentaciones comerciales y pitches'
  },
  {
    id: 'training',
    name: 'Capacitación',
    color: 'text-teal-800',
    bgColor: 'bg-teal-100',
    borderColor: 'border-teal-200',
    darkColor: 'dark:text-teal-200',
    darkBgColor: 'dark:bg-teal-900/40',
    darkBorderColor: 'dark:border-teal-700',
    icon: AcademicCapIcon,
    description: 'Sesiones de entrenamiento y capacitación'
  },
  {
    id: 'follow-up',
    name: 'Seguimiento',
    color: 'text-yellow-800',
    bgColor: 'bg-yellow-100',
    borderColor: 'border-yellow-200',
    darkColor: 'dark:text-yellow-200',
    darkBgColor: 'dark:bg-yellow-900/40',
    darkBorderColor: 'dark:border-yellow-700',
    icon: ClockIcon,
    description: 'Seguimiento post-venta y atención al cliente'
  },
  {
    id: 'special',
    name: 'Evento Especial',
    color: 'text-rose-800',
    bgColor: 'bg-rose-100',
    borderColor: 'border-rose-200',
    darkColor: 'dark:text-rose-200',
    darkBgColor: 'dark:bg-rose-900/40',
    darkBorderColor: 'dark:border-rose-700',
    icon: StarIcon,
    description: 'Eventos especiales y celebraciones'
  }
];
